import { render, staticRenderFns } from "./cargarmaterial.vue?vue&type=template&id=1e5ac4dc"
import script from "./cargarmaterial.vue?vue&type=script&lang=js"
export * from "./cargarmaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports